import { APP_FEATURES } from "../data/appFeatures";
import { AppFeatureCard } from "./AppFeatureCard";

const PHONES_MOBILE = "/assets/pack-zero-franchise/phones-mobile.png";
const PHONES_TABLET_DESKTOP = "/assets/pack-zero-franchise/phones-tablet-desktop.png";

export const AppShowcaseSection = () => {
  return (
    <section
      className={[
        "flex flex-col items-center bg-white",
        "gap-8 pt-20",
        "md:gap-16 md:px-20 md:py-[120px]",
      ].join(" ")}
    >
      <div
        className={[
          "flex flex-col items-center text-center text-[#0D0D0D]",
          "max-w-[343px] gap-2 px-4",
          "md:max-w-[640px] md:gap-3 md:px-0",
        ].join(" ")}
      >
        <h2 className="text-[23px] font-bold leading-[1.2] md:text-[28px]">Remboursement rapide</h2>
        <p className="text-[16px] leading-[1.6] md:text-[19px]">
          Déclarez votre sinistre en un clic et suivez son avancée depuis votre poche
        </p>
      </div>

      <div
        className={[
          "flex w-full flex-col items-center gap-10",
          "md:gap-16",
          "xl:flex-row xl:items-center xl:justify-center",
        ].join(" ")}
      >
        <div
          className={[
            "flex w-full gap-2 overflow-x-auto px-4",
            "md:flex-wrap md:justify-center md:gap-6 md:overflow-visible md:px-0",
            "md:max-w-[606px]",
            "xl:order-last",
            "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
          ].join(" ")}
          tabIndex={0}
          aria-label="Carrousel des fonctionnalités de l’application"
        >
          {APP_FEATURES.map((feature) => (
            <AppFeatureCard key={feature.id} feature={feature} />
          ))}
        </div>

        <img
          src={PHONES_MOBILE}
          alt="Application Roole avec les notes Apple Store et Google Play"
          className="block h-auto w-full max-w-[375px] md:hidden mb-36"
        />
        <img
          src={PHONES_TABLET_DESKTOP}
          alt="Application Roole avec les notes Apple Store et Google Play"
          className="hidden h-auto w-full max-w-[522px] md:block"
        />
      </div>
    </section>
  );
};
